import React, { useState } from "react";
import "../../node_modules/font-awesome/css/font-awesome.min.css";
import { Link } from "react-router-dom";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import logo from "../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-1.png";

const Header = () => {
  const [userAddress, setUserAddress] = useState("");

  const connectWallet = async () => {
    try {
      console.log("hola");
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      setUserAddress(accounts[0]);

      const chainId = await window.ethereum.request({
        method: "eth_chainId",
      });

      if (chainId !== "0x4") {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: "0x4" }],
        });
      }
      console.log(chainId);

      window.ethereum.on("accountsChanged", function (accounts) {
        setUserAddress(accounts[0]);
      });

      window.ethereum.on("chainChanged", (_chainId) =>
        window.location.reload()
      );
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="main-wrapper">
      {/* Header area start */}
      <nav className="navbar navbar-light justify-content-between">
        <Link to="/" className="navbar-brand">
          <img src={logo} alt="logo" /> Lorem
        </Link>
        <div className="justify-content-between">
          <Link to="#">
            <i className="fa fa-search" aria-hidden="true"></i>
          </Link>
          &emsp;
          <Link to="/Drops">Drops</Link>&emsp;
          <Link to="/Marketplace">Marketplace</Link>
          <div className="dropdown">
            <button className="dropbtn">
              <i className="fa fa-user" aria-hidden="true"></i>
            </button>
            <div className="dropdown-content text-left">
              <Link to="/AccountInfo">Account Info</Link>
              <Link to="/AccountActivityBuyer">Account Activity</Link>
              <Link onClick={connectWallet} to="#">
                {!userAddress
                  ? "Connect Wallet"
                  : `${userAddress.slice(0, 5)}...${userAddress.slice(-5)}`}
              </Link>
              <Link to="/UserProfileBuyer">Buyer Profile</Link>
              <Link to="/CollectionDetails">Add New Collections</Link>
              <Link to="/LoginSignup">Login</Link>
            </div>
          </div>
        </div>
      </nav>
      {/* Header area end */}

      {/* Nav links area start */}
      <div className="container">
        <div className="row navLinks justify-content-center">
          <div className="col-lg-4 col-sm-0"></div>
          <div className="col-lg-4 col-sm-8 links">
            <Link to="/">Home</Link>
            <Link to="#">About</Link>
            <Link to="#">Service</Link>
            <Link to="#">Contact</Link>
          </div>
          <div className="col-lg-4 col-sm-0"></div>
        </div>
      </div>
      {/* Nav links area end */}
    </div>
  );
};

export default Header;
